import apiClient from "../client";

export const fetchSyncLogs = async () => {
  const response = await apiClient.get("/admin/sync-logs");
  return response.data;
};

export const triggerSync = async (source) => {
  const response = await apiClient.post(`/admin/sync/${source}`);
  return response.data;
};
